import { render } from "./AccountReviews.vue?vue&type=template&id=0481d02a"
import script from "./AccountReviews.vue?vue&type=script&lang=js"
export * from "./AccountReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__